import React, {ReactElement, useEffect, useState} from 'react';
import AppBar from '../components/appbar/AppBar';
import AppFooter from '../components/appFooter/AppFooter';
import ContentContainer from './ContentContainer';

import offersIcon from '../assets/images/top_nav_offers_small.svg';
import shoppingBagIcon from '../assets/images/top_nav_shopping_bag.svg';
import {useAppDispatch, useAppSelector} from '../redux/hooks';

import {useHistory} from 'react-router-dom';
import {
  getCustomerCouponsCountinLS,
  getTotalCartItems,
} from '../core/localstorage-data';
import {setCustomerCouponsCount} from '../redux/offerSlice';
import {
  CHECKOUT_PATH,
  HOME_ROUTE_PATH,
  SHOPPINGBAG_PATH,
  UNLOCKED_OFFERS_ROUTE_PATH,
} from '../routes/route-constants';
import {setCartItemsCount} from '../redux/orderSlice';

type NavigationDrawerContainerProps = {
  children: React.ReactNode;
  sidebarContent?: React.ReactNode;
  onDrawerButtonClicked?: () => void;
};

const NavigationDrawerContainer: React.FC<NavigationDrawerContainerProps> = ({
  children,
  sidebarContent,
  onDrawerButtonClicked,
}: NavigationDrawerContainerProps): ReactElement => {
  const navigate = useHistory();
  const {pathname} = navigate.location;
  const dispatch = useAppDispatch();
  const [showCartItemsCount, setShowCartItemsCount] = useState(false);
  const title = useAppSelector(state => state.globalReducer.appBarTitle);
  const backNavFunction = useAppSelector(
    state => state.globalReducer.appBarBackNavAction,
  );
  const backNavEnabled = useAppSelector(
    state => state.globalReducer.isBackNavEnabled,
  );
  const customerCouponsCount = useAppSelector(
    state => state.offerReducer.customerCouponsCount,
  );
  const orderResp = useAppSelector(state => state.orderReducer.orderResponse);

  if (!customerCouponsCount) {
    const count = getCustomerCouponsCountinLS();
    if (count) {
      dispatch(setCustomerCouponsCount(count));
    }
  }

  const cartItemsCount = useAppSelector(
    state => state.orderReducer.cartItemsCount,
  );
  if (!cartItemsCount) {
    const totalCartItemsCount = getTotalCartItems();
    if (totalCartItemsCount) {
      dispatch(setCartItemsCount(totalCartItemsCount));
    }
  }

  console.log('in drawer');
  useEffect(() => {
    console.log('order resp');
    if (orderResp && orderResp.itemList && orderResp.itemList.length > 0) {
      setShowCartItemsCount(true);
    }
  }, [orderResp]);

  const isHomePage = (): boolean => {
    return !(pathname === '/home' || pathname === '/home/');
  };

  return (
    <>
      <AppBar
        backButtonAction={backNavFunction}
        withDrawer={true}
        onDrawerClicked={onDrawerButtonClicked}
        trailActions={
          <div className="grid grid-cols-2">
            <div className="relative">
              <a
                onClick={() =>
                  navigate.push(
                    `${HOME_ROUTE_PATH}${UNLOCKED_OFFERS_ROUTE_PATH}`,
                  )
                }>
                <img src={offersIcon} />
                {customerCouponsCount > 0 && (
                  <div
                    className="h-6 w-6 rounded-full absolute bottom-3 right-2 bg-red-600 text-white flex items-center justify-center"
                    onClick={() =>
                      navigate.push(
                        `${HOME_ROUTE_PATH}${UNLOCKED_OFFERS_ROUTE_PATH}`,
                      )
                    }>
                    <div>{customerCouponsCount}</div>
                  </div>
                )}
              </a>
            </div>
            <div
              className="relative"
              onClick={() =>
                navigate.push(`${CHECKOUT_PATH}${SHOPPINGBAG_PATH}`)
              }>
              <a>
                <img src={shoppingBagIcon} />
                {cartItemsCount > 0 && (
                  <div className="h-5 w-5 rounded-full absolute bottom-3 right-2 bg-red-600 text-white flex items-center justify-center">
                    <div>{cartItemsCount}</div>
                  </div>
                )}
              </a>
            </div>
          </div>
        }
        centerContent={title ? <b>{title}</b> : undefined}
        showBackNav={backNavEnabled}
      />
      {sidebarContent}
      <ContentContainer>{children}</ContentContainer>
      {isHomePage() && <AppFooter classNames="z-50" />}
    </>
  );
};

export default NavigationDrawerContainer;
